import React from "react";
import { BoxIcon, GlobeIcon, LightningIcon, SearchIcon, ShieldIcon } from "../SVGIcons";
import clsx from "clsx";
import AnimatedContent from "../AnimatedContent";

const Item = ({ title, description, icon }: { title: string, description: string, icon: React.ReactNode }) => {
    return <div className="flex flex-col items-center text-center">
        {icon}
        <div className="text-[20px] font-medium leading-[1.2] tracking-[-0.8px] mt-[24px]">
            {title}
        </div>
        <div className={clsx(
            "text-[14px] text-white/70 leading-[1.5] tracking-[-0.64px] mt-[12px] max-w-full",
            "md:max-w-[200px]"
        )}>
            {description}
        </div>
    </div>;
};
const KeyProtectionFeatures = () => {
    return <div className={clsx(
        "flex flex-col items-center gap-[40px] py-[40px] px-[16px] w-full max-w-[1112px] mx-auto",
        "md:pt-[120px] md:gap-[60px]"
    )}>
        <div className={clsx(
            "text-[32px] font-semibold leading-[1.2] tracking-[-1.28px]",
            "md:text-[46px] md:tracking-[-1.84px]"
        )}>
            <AnimatedContent>
                Key Protection Features
            </AnimatedContent>
        </div>
        <div className={clsx(
            "flex flex-col gap-[24px]",
            "md:flex-row"
        )}>
            <Item
                title="Real-time risk management"
                description="TaoFlow monitors and adjusts positions in real-time to maintain safety."
                icon={<ShieldIcon className="w-[40px] h-[40px]" fillColor="#00FFEE" />}
            />
            <Item
                title="Auto-Liquidations"
                description="Positions are monitored in real time. If the market moves, TaoFlow acts instantly to protect the pool."
                icon={<LightningIcon className="w-[40px] h-[40px]" fillColor="#00FFEE" />}
            />
            <Item
                title="On-Chain Transparency"
                description="All trades, borrows, and liquidations are verifiable on-chain. No black boxes."
                icon={<GlobeIcon className="w-[40px] h-[40px]" fillColor="#00FFEE" />}
            />
            <Item
                title="Audited Smart Contracts"
                description="TaoFlow is fully audited by industry leaders. Bug bounty program is live."
                icon={<SearchIcon className="w-[40px] h-[40px]" fillColor="#00FFEE" />}
            />
            <Item
                title="Depositor Capital is Ring-Fenced"
                description="Losses are absorbed by trader collateral. Depositors never take performance risk."
                icon={<BoxIcon className="w-[40px] h-[40px]" fillColor="#00FFEE" />}
            />
        </div>
    </div>;
};

export default KeyProtectionFeatures;
